export default __webpack_public_path__ + "static/media/beefy-flat-taco.a90f0293.jpg";